import { render } from "./AddPlafondModal.vue?vue&type=template&id=143e3764&scoped=true&ts=true"
import script from "./AddPlafondModal.vue?vue&type=script&lang=ts"
export * from "./AddPlafondModal.vue?vue&type=script&lang=ts"

import "./AddPlafondModal.vue?vue&type=style&index=0&id=143e3764&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143e3764"]])

export default __exports__